import { useParams } from "react-router-dom";
import {
  headerList,
  filtersDefault,
  addFiltersDefault,
} from "../../utils/constant";
import { useModal } from "../../contexts/ModalContext";
import { useDialog } from "../../contexts/DialogContext";
import CallServiceTable from "../../components/Tables/CallServiceTable";
import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
import { FillForm, SendProcedure } from "../../containers/steps";
import ListDocument from "../../components/common/ListDocument";
import GenerateRoadmap from "../../containers/ManegeProcedure/GenerateRoadmap";
import { Tooltip } from "react-tippy";
import RenderProformOrQuotationWithForm from "../../containers/ManegeProcedure/RenderProformOrQuotationWithForm";
import ProformGeneratorForm from "../proformGenerator/ProformGeneratorForm";

const ProceduresInCharge = () => {
  const { rolId } = useParams();
  const { openModal, onClose } = useModal();
  const { openDialog, dialogClose } = useDialog();

  function handleProcedure(procedure, reloadTable) {
    openModal(
      <FillForm
        procedure={{
          ...procedure,
          processStepId: 14,
        }}
        reload={reloadTable}
        onClose={onClose}
        openModal={openModal}
        rolId={rolId}
        step={12}
        typeId="1"
        isGeneral={true}
      />
    );
  }

  function generateSettlementProforma(procedure) {
    openDialog(<RenderLiquidaciónProforma procedure={procedure} />);
  }

  function handleReadProforma(procedure) {
    openModal(<RenderProformOrQuotationWithForm procedure={procedure} onClose={onClose} />);
    // openDialog(
    //   <DialogConfirmation
    //     children={
    //       <H3>¿Estas seguro que quieres extraer los datos del excel?</H3>
    //     }
    //     onClose={dialogClose}
    //     method="post"
    //     url={`Tradecruz/procedure/${procedure.id}/readerXlsxProforma`}
    //     texBtn="Extraer"
    //     handleSuccess={onClose}
    //   />
    // );
  }

  function handleDocument(procedure) {
    openModal(<ListDocument procedure={procedure} />);
  }

  function generateRoadmap(procedure) {
    openDialog(<GenerateRoadmap procedure={procedure} />);
  }

  function handleSendProcedure(procedure, reloadTable) {
    openModal(
      <SendProcedure
        openModal={openModal}
        procedure={{ ...procedure, processStepId: 14 }}
        reload={reloadTable}
        onClose={onClose}
        isInCharge={true}
      />
    );
  }

  function handleProformGenerator(procedure) {
    openDialog(
      <div className="bg-white mb-4 rounded-lg ">
        <ProformGeneratorForm
          procedure={procedure}
          close={dialogClose}
        />
      </div>,
      false
    );
  }

  return (
    <CallServiceTable
      urlApi="/procedure/openProcedures"
      filters={[
        {
          name: "procedureType",
          url: "/procedureType",
          default: "Todos los tramites",
          valueOption: "id",
          labelOption: "name",
        },
        {
          name: "Years",
          default: "",
          type: "multiSelect",
          label: "Gestión",
          defaultValue: { value: '2026', label: '2026' },
          options: [
            {
              label: "2026",
              name: "2026",
              initial: true,
            },
            {
              label: "2025",
              name: "2025",
            },
            {
              label: "2024",
              name: "2024",
            },
            {
              label: "2023",
              name: "2023",
            },
            {
              label: "2022",
              name: "2022",
            },
            {
              label: "2021",
              name: "2021",
            },
            {
              label: "2020",
              name: "2020",
            },
            {
              label: "2019",
              name: "2019",
            },
          ],
        },
        ...filtersDefault,
      ]}
      addUrl={`isByInCharge=true`}
      addFilters={addFiltersDefault}
      header={[
        ...headerList,
        {
          name: "Action",
          type: "action",
          label: "Acciones",
          disabledOnClick: true,
          sticky: true,
          builder: (_, __, data, call, buttons) => {
            return (
              <div className="flex items-center justify-center gap-1 px-1">
                <div
                  className={`text-red-500 text-xl cursor-pointer`}
                  onClick={() => handleSendProcedure(data, call)}
                >
                  <Tooltip
                    title="Enviar"
                    position="right"
                    trigger="mouseenter"
                  >
                    <i className={"fas fa-share-square p-1"}></i>
                  </Tooltip>
                </div>
              </div>
            );
          },
          actions: [
            {
              label: "Enviar correo",
              icon: "fas fa-share-square",
              name: "trz-010-leerProforma",
              action: handleSendProcedure,
              color: "text-[#e74c3c]",
            },
            {
              label: "Leer proforma",
              icon: "fas fa-file-import",
              name: "trz-010-leerProforma",
              action: handleReadProforma,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Generar liquidación - proforma",
              icon: "fas fa-coins",
              action: generateSettlementProforma,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Ver documentos",
              icon: "fa-solid fa-folder",
              action: handleDocument,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Generar hoja de ruta",
              icon: "fas fa-route",
              action: generateRoadmap,
              color: "text-[#1d4ed8] pr-5",
            },
            {
              label: "Generador de proforma",
              icon: "far fa-file-excel",
              name: "trz-020-generadorDeProforma",
              action: handleProformGenerator,
              color: "text-[#1d4ed8] pr-5",
            },
          ],
        },
      ]}
      onClick={handleProcedure}
      indexSelectedRef='id'
    />
  );
};

export default ProceduresInCharge;
